module.exports = __webpack_public_path__ + "static/media/export-icon.f087c8c4.svg";